<router-outlet></router-outlet>

<div *ngIf="!loaded" class="text-center" style="background-color: black; height: 100vh; width: 100vw; padding-top: 12em;">

    <h2> We're just preparing everything for you, please standby...</h2>
    <div class="spinner-border text-primary spinner-grow-lg" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>